import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Rangos } from '@pages/fabrica-credito/interfaces/rangos';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { Response } from '@shared/interfaces/response/response';
import { Producto } from '@p-parametria/mantenimiento/abc-empresas/interfaces/producto';

// Interfaces para el servicio de firmas
export interface IFirmasRequest {
  sUsuario: string;
  iAccion: number;
  sProducto: string;
  iodbc: number;
  sTipo: string;
  sSubTipo: string;
  dRango1: number;
  dRango2: number;
  sPolitica: string;
  sComentario: string;
  iScore: number;
  iScoreOm: number;
}

export interface IFirmasData {
  odbc: number;
  tipo: string;
  rango: number;
  rango2: number;
  comentario: string;
  politica: string;
}

export interface IFirmasResponse {
  success: boolean;
  data: IFirmasData[];
}

export interface IFirmasDeleteResponse {
  success: boolean;
  data: boolean;
}

export interface IOpcionesCutOffResponse {
  success: boolean;
  data: {
    sOpcion: string;
    sValor: string;
  }[];
}

export interface IFirmasAddResponse {
  success: boolean;
  data: boolean;
}

export interface IFirmasUpdateResponse {
  success: boolean;
  data: boolean;
}


const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};
@Injectable({
  providedIn: 'root'
})
export class ProductosService {
  private _url = environment.apiBaseUrl + 'api/Productos/';
  private newUrl = environment.apiNewBackBaseUrl
  constructor(private _http: HttpClient) { }

  read(): Observable<Response> {
    return this._http.get<Response>(this._url);
  }

  create(model: Producto): Observable<Response> {
    let url: string = this._url + 'Create' ;
    return this._http.post<Response>(url, model, httpOption);
  }
  update(model: Producto): Observable<Response> {
    let url: string = this._url + 'Update' ;
    return this._http.put<Response>(url, model, httpOption);
  }

  delete(model: Producto): Observable<Response> {
    let url: string = this._url + 'Delete' ;
    return this._http.request<Response>('delete', url, {
      body: model,
    });
  }

  copy(request: any): Observable<Response> {
    const url = `${this.newUrl}Gastos/GetCopPrdErr`;
    const body = {
      que: 7,
      tipo_prestamo: request.origen,
      descripcion: request.destino
    };
    return this._http.post<Response>(url, body, httpOption);
  }

  getOpcionesTablaScoring(): Observable<Response> {
    const url = `${this.newUrl}OpcionesSolicitud/GetOpcionesVariables`;
    const body = {
      sTabla: "productos",
      sCampo: "tabla_scoring",
      iIdioma: 0
    };
    return this._http.post<Response>(url, body, httpOption);
  }

  getOpcionesFrecuenciaPago(): Observable<Response> {
    const url = `${this.newUrl}OpcionesSolicitud/GetOpcionesVariables`;
    const body = {
      sTabla: "productos",
      sCampo: "frecuencia_pago",
      iIdioma: 0
    };
    return this._http.post<Response>(url, body, httpOption);
  }

  getRutasCriticas(): Observable<Response> {
    const url = `${this.newUrl}RutaCritica/Procesos`;
    const body = {
      Numero_Proceso: 0,
      descripcion: "",
      descriptivo: "",
      duracion: 0,
      costo: 0
    };
    return this._http.post<Response>(url, body, httpOption);
  }

  getFirmas(request: IFirmasRequest): Observable<IFirmasResponse> {
    const url = `${this.newUrl}Firmas/sospa_varscorList`;
    return this._http.post<IFirmasResponse>(url, request, httpOption);
  }

  deleteFirma(request: IFirmasRequest): Observable<IFirmasDeleteResponse> {
    const url = `${this.newUrl}Firmas/sospa_varscorDelete`;
    return this._http.post<IFirmasDeleteResponse>(url, request, httpOption);
  }

  getOpcionesCutOff(): Observable<IOpcionesCutOffResponse> {
    const url = `${this.newUrl}OpcionesSolicitud/GetOpcionesVariables`;
    const body = {
      sTabla: "varscor",
      sCampo: "politica",
      iIdioma: 0
    };
    return this._http.post<IOpcionesCutOffResponse>(url, body, httpOption);
  }

  addFirma(request: IFirmasRequest): Observable<IFirmasAddResponse> {
    const url = `${this.newUrl}Firmas/sospa_varscorAdd`;
    return this._http.post<IFirmasAddResponse>(url, request, httpOption);
  }

  updateFirma(request: IFirmasRequest): Observable<IFirmasUpdateResponse> {
    const url = `${this.newUrl}Firmas/sospa_varscorUpd`;
    return this._http.post<IFirmasUpdateResponse>(url, request, httpOption);
  }
}
